import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.css";

jQuery(function ($) {
    var chevron =
        '<svg xmlns="http://www.w3.org/2000/svg" width="8.394" height="13.961" viewBox="0 0 8.394 13.961"><path d="M-974.979-545l6.273,6.273-6.273,6.273" transform="translate(975.686 545.707)" fill="none" stroke="#001121" stroke-width="2"/></svg>';

    var minSpinnerMs = 400;
    var loadStart = Date.now();

    function hideLoadingOverlay() {
        $("#usersTable").removeClass("dt-loading");
        $("#usersTableLoading").fadeOut(200, function () {
            $(this).remove();
        });
    }

    $("#usersTable").DataTable({
        order: [[6, "desc"]],
        pageLength: 50,
        lengthMenu: [10, 25, 50, 100],
        columnDefs: [{ orderable: false, searchable: false, targets: [7, -1] }],
        language: {
            search: "",
            searchPlaceholder: "Search",
            paginate: {
                previous: chevron,
                next: chevron,
            },
        },
        initComplete: function () {
            var elapsed = Date.now() - loadStart;
            var remaining = Math.max(0, minSpinnerMs - elapsed);
            setTimeout(hideLoadingOverlay, remaining);
        },
    });
});
